<template>
  <v-container class="mt-4">
    <v-row align="center">
      <v-col cols="12" sm="4">
        <v-autocomplete :items="portalCustomers" item-text="customerName" item-value="customerId" v-model="customerId"
                        label="Customer" dense outlined hide-details
                        no-data-text="No portal customers created"
                        @change="$emit('input',customerId)"/>
      </v-col>
    </v-row>


    <v-row align="center" class="mt-4">
      <v-col cols="12" sm="10">
        <v-card flat outlined>
          <v-data-table class="no-sort"  height="calc(100vh - 220px)"
                        calculate-widths disable-filtering disable-pagination disable-sort hide-default-footer
                        no-data-text="No documents uploaded"
                        :items="documents"
                        @dblclick:row="(e,info) => open(info.item)"
                        :headers="[{text:'Name',value:'name',width:'50%'},
                                  {text:'Created',value:'created',width:'40%'},
                                  {text:'',value:'action',width:'10%',align:'center'}]">
            <template v-slot:item.created="{value}">
              {{value | formatDate}}
            </template>
            <template v-slot:header.action>
              <v-btn fab color="primary" small @click="$refs.fileInput.click()"><v-icon>mdi-plus</v-icon></v-btn>
            </template>
            <template v-slot:item.action="{item,index}">
              <v-menu left :close-on-content-click="false" v-model="item.showDelete">
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-delete</v-icon>
                </template>
                <v-card class="pt-6" width="400">
                  <div class="px-4 pb-4">Are you sure you want to delete {{item.name}}?</div>
                  <v-divider/>
                  <v-card-actions class="pr-4">
                    <v-spacer/>
                    <v-btn plain small color="error" class="ml-4" @click="deleteDocument(item.name, index)">Delete</v-btn>
                    <v-btn color="primary" small @click="item.showDelete=false">Cancel</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <input type="file" style="display:none" ref="fileInput" @change="newDocument">
    <v-snackbar :timeout="10000" v-model="error" color="error" top>
      {{uploadError}}
      <v-btn plain @click="error=false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'AppsPortalDocuments',
  props: {
    portalCustomers: {type:Array, required:true},
    value: {type:String, required:true}
  },
  data() {
    return {
      customerId: this.value,

      documents: [],
      maxMB: 2,
      error: false,
      uploadError: '',
    }
  },
  computed: {
    customer() {
      return this.portalCustomers.find(customer => customer.customerId === this.customerId) ?? {documents:[]};
    }
  },
  watch: {
    value() {
      this.customerId = this.value;
      this.getDocuments();
    }
  },
  created() {
    if (this.customerId)
      this.getDocuments();
  },
  methods: {
    async getDocuments() {
      if (!this.customer.documents) {
        const results = await this.$apiCall(`query AppsPortal($customerId:ID!) {
                                                portalCustomer(customerId:$customerId) {
                                                  documents {name,created,url}
                                                }
                                            }`,
                                            {customerId:this.customerId}, false, 'portal');
        if (!results.error) {
          this.customer.documents = results.data.portalCustomer.documents;
        }
      }
      this.documents = this.customer.documents;
    },
    newDocument(event) {
      const file = event.target.files[0];
      this.uploadError = '';
      if (file == null)
        return;
      const maxSize = this.maxMB * 1024*1024;
			if (file.size / maxSize > 1) {
        this.uploadError = `File size must be less than ${this.maxMB}MB`;
        this.error = true;
				return;
			}
      const reader = new FileReader();
      reader.onload = async loadEvent => {
        this.url = loadEvent.target.result;
        const results = await this.$apiCall(`mutation AppsPortalDocuments($input:PortalDocumentInput!) {
                                              portalDocumentCreate(input:$input) {
                                                name,created,url
                                              }
                                          }`,
                                          {input:{customerId:this.customerId,name:file.name,contents:loadEvent.target.result}}, false, 'portal');
        if (!results.error) {
          this.documents.push(results.data.portalDocumentCreate)
          this.$store.commit('setError', {type:'success', message:`Uploaded document ${file.name}`});
        }
      }
      reader.onError = () => {
        this.uploadError = 'Error reading file';
        this.error = true;
      }
      reader.readAsDataURL(file);
      this.$refs.fileInput.type='text';   // Required to allow uploading same file
      this.$refs.fileInput.type='file';
    },

    async deleteDocument(name, index) {
      const results = await this.$apiCall(`mutation AppsPortalDocuments($customerId:ID!, $name:String!) {
                                              portalDocumentDelete(customerId:$customerId,name:$name)
                                            }`,
                                            {customerId:this.customerId,name}, false, 'portal');
      if (!results.error) {
        this.documents.splice(index, 1);
        this.$store.commit('setError', {type:'success', message:`Deleted document ${name}`});
      }
    },

    open(document) {
      if (document.url.substring(0, 5) !== 'data:') {
        const win = window.open(document.url);
        if (!win) {
          this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
          return;
        }
      }
      else {
        const win = window.open();
        if (!win) {
          this.$store.commit('setError', {type:'warning',message:`Your browser permissions must allow pop-up windows`});
          return;
        }
        const document = win.document;
        const obj = document.createElement('object');
        obj.style.width="100%";
        obj.style.height="100%";
        obj.data = document.url;
        document.body.appendChild(obj);
        win.document.close();
        win.focus();
      }
    }
  }
}
</script>